import { PhaseStub } from '@/components/PhaseStub'

const SCREENS: Record<string, { title: string; phase: number; summary: string; blockedBy: string }> = {
  journal: {
    title: 'Journal',
    phase: 9,
    summary: 'Closed trades with the full charges breakdown, notes and tags.',
    blockedBy: 'Phase 6 — closed positions to journal',
  },
  schedule: {
    title: 'Schedule',
    phase: 8,
    summary:
      'Time-of-day strategy deployment, with a trading calendar so a holiday or a Muhurat session is a modelled state rather than a support message.',
    blockedBy: 'Phase 7 — a strategy to schedule',
  },
  drafts: {
    title: 'Drafts',
    phase: 7,
    summary: 'Saved strategy definitions, built from the chain and deployed when you choose.',
    blockedBy: 'Phase 5 — the deployment path',
  },
  learn: {
    title: 'Learn',
    phase: 9,
    summary: 'How the terminal works, and what each risk gate refuses.',
    blockedBy: 'the gates existing to document',
  },
}

export default function NotBuilt({ screen }: { screen: keyof typeof SCREENS }) {
  const s = SCREENS[screen]
  if (!s) return <PhaseStub title="Not found" phase={0} summary="No such screen." />
  return <PhaseStub {...s} />
}
